import { AdEndpointViews, getAdDecisionByType, hasAd } from '@/app/util/ads-endpoint'
import AdsContext from '@/context/ads'
import { useContext } from 'react'
import { isEmpty } from 'utils'
import { isValidActiveBanner } from '../app/util/banner'
import UAParserContext from '../context/ua-parser'
import AdBanner from './homepage/ad-banner'

const Banner = () => {
    const { deviceType } = useContext(UAParserContext)
    const { banner } = useContext(AdsContext)

    if (!banner || isEmpty(banner)) {
        return null
    }
    const isAdBanner = !isValidActiveBanner(banner)
    return isAdBanner ? (
        <AdBanner gif={banner} deviceType={deviceType} />
    ) : (
        <div
            className="ci-hidden h-[22vw] md:h-[96px] md:w-desktopWidth"
            onClick={() => {
                location.href = banner.link
            }}
        >
            <img
                className="h-full w-full object-cover"
                src={deviceType === 'desktop' ? banner.image : banner.image_mobile}
                alt={banner.alt_text}
            />
        </div>
    )
}

const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
export const AdEndpointBanner = ({ view }: { view: AdEndpointViews }) => {
    const { adClientData, adServerData } = useContext(AdsContext)
    const adDecision = getAdDecisionByType(adClientData, view)
    const gifId = adDecision?.gif?.id
    const src = gifId ? `https://media.giphy.com/media/${gifId}/giphy.webp` : placeholder
    return hasAd(view, adServerData) ? (
        <div className="ci-hidden h-[22vw] md:h-[96px] md:w-desktopWidth">
            <img
                src={src}
                alt=""
                className="h-full w-full object-cover"
                onError={(e) => {
                    console.error(`AdEndpointBanner error loading ${gifId}`, e)
                }}
            />
        </div>
    ) : null
}

export default Banner
